SCM = SCM || {};

SCM.BookPartTitleFacet = (function ($) {
    return {
        init: init,
        showAllItems: showAllItems,
        toggleBookPartTitleParent: toggleBookPartTitleParent
    };

    function init() {
        if (!myComponentIsOnPage()) {
            return;
        }
        toggleBookPartTitleParent();
        bindEvents();
    }

    function showAllItems() {
        $('.js-bookparttitle-child-list-item').removeClass('hide');
    }

    function myComponentIsOnPage() {
        return $('.pg_book .js-bookparttitle-facet').length;
    }
    function bindEvents() {
        $(document).on('click', '.js-bookparttitle-arrow', arrowOnClick);
        $(document).on('click', '.js-bookparttitle-label:not(.js-bookparttitle-checkbox)', labelOnClick);
        $(document).on('click', '.js-bookparttitle-checkbox', checkboxOnClick);
    }

    function arrowOnClick() {
        var $icon = $(this).find('.js-bookparttitle-arrow-icon');
        if (!$icon.length) {
            $icon = $(this).parent().find('.js-bookparttitle-arrow-icon');
        }
        if (!$icon.length) {
            console.error('.js-bookparttitle-arrow-icon not found');
            return;
        }

        let $parentLiItem = $icon.closest('.js-bookparttitle-child-list-item');
        let $bookparttitleUl = $parentLiItem.find('ul.bookparttitle-child-list');
        let $bookparttitleCheckbox = $parentLiItem.find('.js-bookparttitle-checkbox');
        var $placeholder = $parentLiItem.find('.js-bookparttitle-headings-placeholder');


        if ($icon.hasClass('icon-general-arrow-filled-right')) {

            $icon.removeClass('icon-general-arrow-filled-right');
            $icon.addClass('icon-general-arrow-filled-down');

            $bookparttitleUl.attr('aria-expanded', 'true');
            $bookparttitleCheckbox.attr('aria-expanded', 'true');
        } else if ($icon.hasClass('icon-general-arrow-filled-down')) {

            $icon.removeClass('icon-general-arrow-filled-down');
            $icon.addClass('icon-general-arrow-filled-right');

            $bookparttitleUl.attr('aria-expanded', 'false');
            $bookparttitleCheckbox.attr('aria-expanded', 'false');
        }
        $placeholder.toggleClass('hide');
    }

    function labelOnClick(e) {
        var $checkbox = $(this).closest('.js-bookparttitle-item').find('.js-bookparttitle-checkbox').first();
        toggleCheckbox($checkbox);

        var $checkBoxContainer = $(this).closest('.js-bookparttitle-child-list-item');
        updateFacetDescendantCheckboxes($checkbox, $checkBoxContainer, '.js-bookparttitle-checkbox');
        doBookPartTitleFacetQuery();
    }
    function toggleCheckbox($checkbox) {
        if ($checkbox.is(':checked')) {
            $checkbox.prop('checked', false);
        } else {
            $checkbox.prop('checked', true);
        }
    }

    function checkboxOnClick() {
        var $checkBoxContainer = $(this).closest('.js-bookparttitle-child-list-item');
        updateFacetDescendantCheckboxes($(this), $checkBoxContainer, '.js-bookparttitle-checkbox');
        doBookPartTitleFacetQuery();
    }

    function doBookPartTitleFacetQuery() {
        var currentDataUrl = getCurrentDecodedUrl();

        var facetValues = getFacetValues();
        var updatedUrl = getUpdatedQueryString(currentDataUrl, facetValues);
        

        SCM.SearchResults.doSolrSearch({ queryString: updatedUrl });
    }

    function getCurrentDecodedUrl() {
        var currentDataUrl = $('#BookPartTitleCurrentDataUrl').val();
        return decodeURIComponent(currentDataUrl);
    }

    function getFacetValues() {
        var facetValues = [];
        $('.js-bookparttitle-facet').find('.js-bookparttitle-checkbox:checked').each(function () {
            var $parent = $(this).parents('.js-parent');
            if ($parent.length) {
                var $parentCheckbox = $parent.find('.js-bookparttitle-checkbox:first:checked');
                if ($parentCheckbox.length) {
                    var dataId = $parentCheckbox.data('facetvalue');
                    if (facetValues.indexOf(dataId) === -1) {
                        facetValues.push(dataId);
                    }
                }
                else {
                    facetValues.push($(this).data('facetvalue'));
                }
            }
        });

        return facetValues;
    }

    function getUpdatedQueryString(currentDataUrl, facetValues) {
        var facetQsPo = currentDataUrl.indexOf('f_BookPartTitle=');
        var facetQsPresent = (facetQsPo === -1) ? false : true;

        if (!facetQsPresent && facetValues.length > 0) {
            currentDataUrl += '&f_BookPartTitle=' + facetValues.join('AND');
        } else if (facetQsPresent) {

            var facetQueryTerm = SCM.JSUtility.getSearchParamByName('f_BookPartTitle').replace(/ /g, '+');
            if (facetQueryTerm && facetQueryTerm !== '') {

                if (facetValues.length > 0) {
                    var newQuery = 'f_BookPartTitle=' + facetValues.join('AND');
                    currentDataUrl = currentDataUrl.replace('f_BookPartTitle=' + facetQueryTerm, newQuery);
                } else {
                    var existingQuery = 'f_BookPartTitle=' + facetQueryTerm;
                    var startIndex = currentDataUrl.indexOf(existingQuery);
                    var endIndex = startIndex + existingQuery.length;

                    if (currentDataUrl.charAt(startIndex - 1) === '&') {
                        existingQuery = '&' + existingQuery;
                    } else if (currentDataUrl.charAt(endIndex + 1) === '&') {
                        existingQuery = existingQuery + '&';
                    }

                    currentDataUrl = currentDataUrl.replace(existingQuery, '');
                }
            }
        }
        return currentDataUrl;
    }

    function updateFacetDescendantCheckboxes($checkbox, $checkBoxContainer, checkboxClass) {
        var $parent = $checkbox.closest('.js-parent');
        if (!$parent.length) {
            return;
        }

        var isChecked = $checkbox.is(':checked')

        if (isParentCheckBoxChecked($parent, $checkBoxContainer)) {
            $parent.find(checkboxClass).prop('checked', isChecked);
        }
        else {
            updateParentCheckboxWithChildrenValue($parent, checkboxClass);
        }
    }

    function isParentCheckBoxChecked($parent, $checkBoxContainer) {
        return $parent[0] === $checkBoxContainer[0];
    }

    function updateParentCheckboxWithChildrenValue($parent, checkboxClass) {

        var $childCheckboxes = $parent.find('li ' + checkboxClass);
        var $checkedChildren = $parent.find('li ' + checkboxClass + ':checked');
        $parent.find(checkboxClass + ':first').prop('checked', $childCheckboxes.length === $checkedChildren.length);
    }

    function toggleBookPartTitleParent() {
        $checkedItems = $('.bookparttitle-checkbox:checked');
        if ($checkedItems.length > 0) {
            $checkedItems.parents('.js-bookparttitle-child-list-item').each(function () {
                expandChildList($(this)); 
            });
        }
    }
    function expandChildList($childListItem) {
        var $arrowLink = $childListItem.find('.js-bookparttitle-arrow').first();
        var $icon = $arrowLink.children('.js-bookparttitle-arrow-icon');
        if ($arrowLink && $arrowLink.length && $icon.hasClass('icon-general-arrow-filled-right')) {
            $arrowLink.parent('.js-bookparttitle-item').children('.js-bookparttitle-headings-placeholder').toggleClass('hide');
            $icon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
        }
    }
})(jQuery);